export default __webpack_public_path__ + "static/media/step-3-de.1e423aac.png";